import { render, staticRenderFns } from "./chartBFP.vue?vue&type=template&id=13a5250c"
import script from "./chartBFP.vue?vue&type=script&lang=js"
export * from "./chartBFP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports